module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Promo12.d49e3496.jpg";